"use client"

import { useEffect, useRef, useState, type ReactNode } from "react"

import { Button } from "@/components/ui"

interface DescriptionExcerptProps {
  preview: string
  moreLabel: string
  children: ReactNode
  className?: string
}

export const DescriptionExcerpt = ({ preview, moreLabel, children, className }: DescriptionExcerptProps) => {
  const [open, setOpen] = useState(false)
  const [clipped, setClipped] = useState<boolean | null>(null)
  const text = useRef<HTMLParagraphElement>(null)

  useEffect(() => {
    const element = text.current
    if (!element || open) return
    const measure = () => setClipped(element.scrollHeight > element.clientHeight + 1)
    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(element)
    return () => observer.disconnect()
  }, [open])

  if (open) return <div className={className}>{children}</div>
  return (
    <div className="flex flex-col items-start gap-100">
      <p ref={text} className={`line-clamp-3 ${className ?? ""}`}>
        {preview}
      </p>
      {clipped !== false && (
        <Button
          variant="quiet"
          onClick={() => setOpen(true)}
          aria-expanded={false}
          className={`${clipped ? "" : "invisible"} text-fg-brand hover:text-brand-hover font-text text-copy @3xl:text-copy-lg h-auto p-0 font-normal underline underline-offset-2`}
        >
          {moreLabel}
        </Button>
      )}
    </div>
  )
}
